import React from 'react';

import { convertToNumber } from 'utils/converters';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import { LoadingError } from 'components/shared/LoadingError/LoadingError';

import { CreateEditDutyHourTypesSkeleton } from '../skeletons/CreateEditDutyHourTypesSkeleton';
import { CreateEditDutyHourTypesForm } from './CreateEditDutyHourTypesForm';
import { useGetDetails } from './hooks/useGetDetails';

export const DutyHourTypeDataLoaderFeedback: React.FC<FormComponentProps> = ({
  handleClose,
  rowId
}) => {
  const { isFetching, data, error, refetch } = useGetDetails(
    convertToNumber(rowId)
  );

  return isFetching ? (
    <CreateEditDutyHourTypesSkeleton />
  ) : error ? (
    <LoadingError reFetch={refetch} />
  ) : (
    <CreateEditDutyHourTypesForm handleClose={handleClose} rowData={data} />
  );
};
